import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=bc6f6d02&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3767387119/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc6f6d02')) {
      api.createRecord('bc6f6d02', component.options)
    } else {
      api.reload('bc6f6d02', component.options)
    }
    module.hot.accept("./Search.vue?vue&type=template&id=bc6f6d02&", function () {
      api.rerender('bc6f6d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/Search.vue"
export default component.exports